global.version = "1.0.5";

/**
 * คลี่เมนูกลุ่มออกเป็นรายการเดียว — เมนูกลุ่ม (ทรัพย์ / การตลาด / รายงาน / ตั้งค่า /
 * จัดการหน้าแรก) เก็บ link ไว้ที่เมนูลูก ถ้าไม่คลี่ก่อน ตัวช่วยด้านล่างจะมองไม่เห็น
 * และคืนค่าเหมือนผู้ใช้ไม่มีสิทธิ์อะไรเลย
 * @param {Array} menu
 * @returns {Array}
 */
const flattenMenu = (menu) => (menu || []).flatMap((item) => (item.children ? item.children : [item]));

/**
 * เช็คว่า user มี permission ให้เข้าโมดูลนี้ได้ไหม โดยดูจากทุกเมนูในโมดูล
 * (ไม่ใช่แค่ permission ของหน้า dashboard) ป้องกันกรณี user มีสิทธิ์เมนูอื่น
 * ในโมดูล แต่ไม่มีสิทธิ์ dashboard แล้วเข้าโมดูลไม่ได้เลย
 * @param {Array} menu - global.menu_admin / menu_customer / menu_warehouse / menu_super_user
 * @param {Array<string>} perms - user_profile.role.permission
 * @returns {boolean}
 */
global.hasModuleAccess = function (menu, perms) {
  const permSet = new Set(perms || []);
  return flattenMenu(menu).some((item) => item.link && item.permission && permSet.has(item.permission));
};

/**
 * หาลิงก์แรกในเมนูที่ user มี permission เข้าถึง ใช้แทนการ hardcode ไปหน้า dashboard
 * @param {Array} menu - global.menu_admin / menu_customer / menu_warehouse / menu_super_user
 * @param {Array<string>} perms - user_profile.role.permission
 * @returns {string|null}
 */
global.getFirstAccessibleLink = function (menu, perms) {
  const permSet = new Set(perms || []);
  const item = flattenMenu(menu).find((m) => m.link && m.permission && permSet.has(m.permission));
  return item ? item.link : null;
};

/**
 * หน้าแรกหลังเข้าสู่ระบบ — ต้องคิดจากสิทธิ์ ไม่ใช่ยิงไป dashboard ตายตัว
 * ไม่งั้นบทบาทที่ไม่มี dashboard-admin.read จะโดน PermissionRoute เด้งออกทันทีที่ล็อกอิน
 * @param {Object} profile - ข้อมูลจาก GET admin/users/profile
 * @returns {string}
 */
global.getAdminHomeLink = function (profile) {
  // super_user ข้ามการตรวจสิทธิ์รายหน้า จึงเข้าแดชบอร์ดได้เสมอ
  if (profile?.user_type === "super_user") return "/ad/dashboard";

  /* พาร์ตเนอร์ใช้หลังบ้านได้แล้ว (แดชบอร์ด · ทรัพย์ · การตลาด · ลูกค้า · นัดหมาย · รายงาน
     — ดู migration 20260825000000) บรรทัดล่างจึงพาไปเมนูแรกที่บทบาทเข้าได้ตามปกติ

     เงื่อนไขนี้เหลือไว้เป็นทางลงของบัญชีที่ "ไม่เหลือเมนูให้เข้าเลย" เช่นบทบาทถูกถอด
     สิทธิ์ออกหมดภายหลัง หรือฐานข้อมูลยังไม่ได้รัน migration นั้น — ถ้าปล่อยให้ตกไป
     บรรทัดล่างจะได้ /ad/dashboard แล้วโดน PermissionRoute เด้งไปหน้า not found
     ทันทีที่ล็อกอิน ซึ่งอ่านไม่ออกว่าเกิดอะไรขึ้น พากลับหน้าเว็บสาธารณะแทน
     (แถบเมนูที่นั่นจะแสดงว่าล็อกอินอยู่) */
  if (profile?.user_type === "partner" && !global.hasModuleAccess(global.menu_admin, profile?.role?.permission)) {
    return "/";
  }

  // ไม่เหลือเมนูที่เข้าได้เลย : ส่งไปแดชบอร์ดตามเดิมแล้วให้ PermissionRoute แจ้งเอง
  return global.getFirstAccessibleLink(global.menu_admin, profile?.role?.permission) || "/ad/dashboard";
};

/**
 * โครงเมนูฝั่ง Admin
 * - item ที่มี title    = หัวข้อคั่นกลุ่ม
 * - item ที่มี children = เมนูพับเก็บได้ (กดเพื่อกาง/หุบ)
 * - item ที่มี cta      = ปุ่มเด่น (ใช้สีเดียวกับปุ่มหลักหน้า login)
 * - item ที่มี type     = ใช้หน้าเดิมแต่กรองด้วย query ?type=... (ไม่แยกหน้าใหม่)
 * - item ที่มี coming_soon = ยังไม่เปิดใช้งาน กดแล้วขึ้นแจ้งเตือนแทนการเข้าหน้า
 * - item ที่มี badge     = ตัวเลขงานค้างบนเมนู — ค่านี้เป็น "ชื่อแหล่งข้อมูล" ไม่ใช่ตัวเลข
 *                          NavbarAdmin เป็นคนไปดึงยอดมาใส่ (ดู BADGE_SOURCES ที่นั่น)
 *
 * permission = สิทธิ์ขั้นต่ำที่ต้องมีถึงจะเห็นเมนูและเข้าหน้านั้นได้ ใช้ .read ของโมดูล
 * เสมอ (ดู/เพิ่ม/แก้/ลบ แยกกันที่ปุ่มในหน้า) ไฟล์นี้เป็นแหล่งความจริงเดียว —
 * NavbarAdmin ใช้กรองเมนู และ PermissionRoute ใช้กันการพิมพ์ URL เข้าตรง ๆ
 *
 * เมนูกลุ่มไม่ต้องตั้ง permission เอง : ถ้าเมนูลูกถูกกรองจนไม่เหลือ ทั้งกลุ่มจะหายไปเอง
 * key ที่ใช้ต้องมีอยู่ใน global.permission ด้านล่างและในตาราง permissions ฝั่ง backend
 */
global.menu_admin = [
    { title: "main_menu" },
    { icon: "\uf0e4", name: "dashboard", link: "/ad/dashboard", permission: "dashboard-admin.read", component: "" },
    {
        icon: "\uf015",
        name: "all_properties",
        children: [
            { name: "all", link: "/ad/assets", permission: "assets.read" },
            { name: "projects", link: "/ad/projects", permission: "projects.read" },
            { name: "property_categories", link: "/ad/property-types", permission: "asset-categories.read" },
        ],
    },
    {
        // การตลาด — คิวงานโพสต์ทรัพย์ลงช่องทางต่าง ๆ + ข้อมูล master ของช่องทาง
        icon: "\uf0a1",
        name: "marketing",
        children: [
            { name: "marketing_board", link: "/ad/marketing", permission: "marketing.read" },
            { name: "marketing_channels", link: "/ad/marketing/channels", permission: "marketing-channels.read" },
        ],
    },
    { icon: "\uf0c0", name: "customers", link: "/ad/customers", permission: "customers.read", component: "" },
    { icon: "\uf073", name: "appointments", link: "/ad/appointments", permission: "appointments.read", component: "" },
    /* พาร์ตเนอร์ — ใบสมัครนายหน้าภายนอกที่เข้ามาจากหน้าเว็บสาธารณะ (/partner)
       วางไว้หลังงานขาย เพราะเป็นงานตรวจเอกสาร/อนุมัติ ไม่ใช่งานที่ทำทุกวันเหมือนลูกค้า
       การอนุมัติใช้สิทธิ์ partners.approve ต่างหาก แต่การ "เห็นเมนู" ใช้ .read ตามกติกาเดิม */
    { icon: "\uf2b5", name: "partners", link: "/ad/partners", permission: "partners.read", component: "", badge: "partners_open" },
    /* รายการเติมเหรียญ — คิวตรวจคำขอเติมเหรียญของพาร์ตเนอร์ (เช็คเงินเข้าจากสลิป)
       วางต่อจากเมนูพาร์ตเนอร์เพราะเป็นงานที่ทำกับคนกลุ่มเดียวกัน แต่คนละหน้าที่ :
       เมนูบนคือตรวจ "ตัวคน" ตอนรับเข้าระบบ เมนูนี้คือตรวจ "เงิน" ที่โอนเข้ามาทุกวัน
       และมักเป็นคนละทีมกัน (ฝ่ายการเงิน) สิทธิ์จึงแยกชุดกัน ไม่ใช้ partners.* */
    { icon: "\uf543", name: "topup_review", link: "/ad/wallet/topups", permission: "wallet-topups.read", component: "", badge: "topups_open" },
    {
        icon: "\uf080",
        name: "reports",
        children: [
            { name: "property_report", link: "/ad/reports/property", permission: "reports.read" },
            { name: "sales_report", link: "/ad/reports/sales", permission: "reports.read" },
        ],
    },
    {
        icon: "\uf013",
        name: "settings",
        children: [
            { name: "company_profile", link: "/ad/settings", permission: "settings.read" },
            { name: "watermark_setting", link: "/ad/watermark", permission: "watermark.read" },
            /* ตั้งค่าเหรียญ — นโยบายของระบบเหรียญทั้งระบบ (อัตราแลกเปลี่ยน เพดาน เหรียญต้อนรับ)
               อยู่กลุ่มเดียวกับค่าตั้งค่าอื่นของบริษัท ไม่ใช่เมนูพาร์ตเนอร์ เพราะแก้ทีเดียว
               กระทบทุกกระเป๋าพร้อมกัน ส่วนการปรับยอดรายคนยังอยู่ที่หน้าพาร์ตเนอร์ */
            { name: "wallet_setting", link: "/ad/wallet-settings", permission: "wallet-settings.read" },
            { name: "users", link: "/ad/users", permission: "users.read" },
            { name: "roles", link: "/ad/roles", permission: "roles.read" },
        ],
    },
    { title: "home_page_menu" },
    // จัดการเนื้อหาแต่ละส่วนของหน้าแรกฝั่งลูกค้า (แก้แล้วเห็นผลที่หน้าแรกทันที)
    // ทั้งกลุ่มใช้สิทธิ์ homepage.read ร่วมกัน เพราะ backend มีปลายทางเดียว
    // (GET admin/homepage/:group) ไม่ได้แยกสิทธิ์รายส่วน
    {
        icon: "\uf2d0",
        name: "home_manage",
        children: [
            /* เรียงตามลำดับที่แต่ละส่วนปรากฏบนหน้าแรก ผู้ดูแลจะได้ไล่แก้จากบนลงล่างได้ */
            { name: "home_hero_manage", link: "/ad/home/hero", permission: "homepage.read" },
            { name: "home_shortcut_manage", link: "/ad/home/shortcuts", permission: "homepage.read" },
            { name: "home_banner_manage", link: "/ad/home/banners", permission: "homepage.read" },
            /* การ์ดลงประกาศฟรีอยู่ข้างแบนเนอร์บนหน้าแรก จึงวางต่อกันในเมนู
               (คุมรูปในการ์ด + LINE ID ปลายทางของปุ่มลงประกาศฟรีทุกปุ่มบนเว็บ) */
            { name: "home_post_manage", link: "/ad/home/post", permission: "homepage.read" },
            { name: "home_feature_manage", link: "/ad/home/features", permission: "homepage.read" },
            { name: "home_article_manage", link: "/ad/home/articles", permission: "homepage.read" },
            /* เอกสารทางกฎหมายอยู่คนละหน้ากับหน้าแรก (เปิดจากแถบล่างของฟุตเตอร์)
               แต่เก็บเนื้อหาด้วยกลไกเดียวกัน จึงรวมไว้ในเมนูกลุ่มนี้และใช้สิทธิ์ชุดเดียวกัน */
            { name: "home_privacy_manage", link: "/ad/home/privacy", permission: "homepage.read" },
            { name: "home_terms_manage", link: "/ad/home/terms", permission: "homepage.read" },
        ],
    },
];

/**
 * ปุ่มลัดไปดูหน้าเว็บฝั่งลูกค้า (ข้อความปุ่ม = คีย์ view_homepage)
 * แยกออกจาก menu_admin เพราะ Navbar เอาไปวางไว้ล่างสุดของแถบเมนู (เหนือชื่อผู้ใช้)
 * ไม่ได้ปนอยู่ในลิสต์เมนูที่เลื่อนขึ้นลง — เปิดแท็บใหม่ไม่ให้หลุดจากงานที่ทำค้างไว้
 *
 * หน้าแรก (/) เป็นหน้าสาธารณะ เปิดดูได้โดยไม่ต้องล็อกอิน จึงไม่ผูก permission
 */
global.menu_admin_cta = {
    icon: "\uf35d",
    name: "view_homepage",
    link: "/",
    permission: "",
    new_tab: true,
};

/**
 * หน้าที่ไม่ได้อยู่ในแถบเมนู (เข้าจากปุ่มในหน้าอื่น) จึงไม่มีที่ประกาศสิทธิ์ใน menu_admin
 * ต้องมาประกาศที่นี่ ไม่งั้น PermissionRoute จะกันไว้หมดเพราะกันแบบ "ไม่ประกาศ = ไม่ให้เข้า"
 *
 * ส่วนที่เป็นค่าแปรผันใช้ ":" นำหน้า เช่น /ad/assets/:uid/edit (เทียบทีละส่วนที่คั่นด้วย /)
 * หน้าเหล่านี้เป็นฟอร์มเขียนข้อมูล จึงขอสิทธิ์ create/update ไม่ใช่ read
 */
global.route_permission = [
    { path: "/ad/assets/create", permission: "assets.create" },
    { path: "/ad/assets/:uid/edit", permission: "assets.update" },
];

global.permission = [
    // แดชบอร์ดอ่านอย่างเดียว ไม่มีปลายทางสำหรับเพิ่ม/แก้/ลบ
    "dashboard-admin.read",

    "permissions.read",
    "permissions.create",
    "permissions.update",
    "permissions.delete",
    
    "roles.read",
    "roles.create",
    "roles.update",
    "roles.delete",
    
    "users.read",
    "users.create",
    "users.update",
    "users.delete",

    "assets.read",
    "assets.create",
    "assets.update",
    "assets.delete",

    "asset-categories.read",
    "asset-categories.create",
    "asset-categories.update",
    "asset-categories.delete",

    "projects.read",
    "projects.create",
    "projects.update",
    "projects.delete",

    "marketing.read",
    "marketing.create",
    "marketing.update",
    "marketing.delete",

    "marketing-channels.read",
    "marketing-channels.create",
    "marketing-channels.update",
    "marketing-channels.delete",

    "customers.read",
    "customers.create",
    "customers.update",
    "customers.delete",

    "appointments.read",
    "appointments.create",
    "appointments.update",
    "appointments.delete",

    "partners.read",
    "partners.create",
    "partners.update",
    "partners.delete",
    // อนุมัติ / ไม่อนุมัติ / ระงับใบสมัคร — แยกจาก update เพราะเป็นการเปิดบัญชี
    // เข้าใช้งานระบบให้คนนอก ไม่ใช่ระดับเดียวกับการแก้ข้อมูลในใบสมัคร
    "partners.approve",

    "reports.read",

    "settings.read",
    "settings.update",

    "watermark.read",
    "watermark.update",

    // ตั้งค่าระบบเหรียญ — มีแค่ดูกับแก้ไข เพราะเป็นตารางแถวเดียวของทั้งระบบ
    "wallet-settings.read",
    "wallet-settings.update",

    /* คำขอเติมเหรียญของพาร์ตเนอร์
       approve แยกจาก update โดยตั้งใจ — การอนุมัติคือการทำให้เหรียญเข้ากระเป๋าจริง
       ทีมที่ให้เปิดดูและแก้หมายเหตุได้ แต่ไม่ให้กดอนุมัติเอง จึงตั้งค่าได้จากหน้าบทบาท */
    "wallet-topups.read",
    "wallet-topups.update",
    "wallet-topups.approve",

    // จัดการเนื้อหาหน้าแรกของเว็บลูกค้า — backend มีปลายทางเดียวสำหรับทุกส่วน
    // (GET/PUT admin/homepage/:group) จึงมีแค่ดูกับแก้ไข
    "homepage.read",
    "homepage.update",
];

global.bank = [
  { icon: "CIMB.png", value: "CIMB", label: "CIMB Thai", name_th: "ธนาคารซีไอเอ็มบีไทย", code: "022",},
  { icon: "LHB.png", value: "LHB", label: "Land and Houses Bank", name_th: "ธนาคารแลนด์แอนด์เฮ้าส์", code: "073",},
  { icon: "TCRB.png", value: "TCRB", label: "The Thai Credit Retail Bank", name_th: "ธนาคารไทยเครดิตเพื่อรายย่อย", code: "071",},
  { icon: "KKP.png", value: "KKP", label: "Kiatnakin Bank", name_th: "ธนาคารเกียรตินาคิน", code: "069",},
  { icon: "TISCO.png", value: "TISCO", label: "Tisco Bank", name_th: "ธนาคารทิสโก้", code: "067",},
  { icon: "IBANK.png", value: "IBANK", label: "Islamic Bank of Thailand", name_th: "ธนาคารอิสลามแห่งประเทศไทย", code: "066",},
  { icon: "HSBC.png", value: "HSBC", label: "Hong Kong & Shanghai Corporation", name_th: "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น", code: "030",},
  { icon: "UOB.png", value: "UOB", label: "United Overseas Bank", name_th: "ธนาคารยูโอบี (ไทย)", code: "024",},
  { icon: "ICBC.png", value: "ICBC", label: "Industrial and Commercial Bank of China Limited", name_th: "ธนาคารพาณิชย์อุตสาหกรรมแห่งประเทศจีน", code: "070",},
  { icon: "BAAC.png", value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives", name_th: "ธ.ก.ส.", code: "034",},
  { icon: "GHB.png", value: "GHB", label: "Government Housing Bank", name_th: "ธนาคารอาคารสงเคราะห์", code: "033",},
  { icon: "GSB.png", value: "GSB", label: "Government Savings Bank", name_th: "ธนาคารออมสิน", code: "030",},
  { icon: "BAY.png", value: "BAY", label: "Bank of Ayudhya", name_th: "ธนาคารกรุงศรีอยุธยา", code: "025",},
  { icon: "KTB.png", value: "KTB", label: "Krung Thai Bank", name_th: "ธนาคารกรุงไทย", code: "006",},
  { icon: "BBL.png", value: "BBL", label: "Bangkok Bank", name_th: "ธนาคารกรุงเทพ", code: "002",},
  { icon: "TTB.png", value: "TTB", label: "TTB Thanachart Bank", name_th: "ธนาคารทหารไทยธนชาต", code: "011",},
  { icon: "KBANK.png", value: "KBANK", label: "Kasikorn Bank", name_th: "ธนาคารกสิกรไทย", code: "004",},
  { icon: "SCB.png", value: "SCB", label: "Siam Commercial Bank", name_th: "ธนาคารไทยพาณิชย์", code: "014",},

];